import React, { useEffect, useState } from 'react';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ILoginState, logout } from '@share/store/slices';

//import img from '@assets/images/avatar/avatar01.png';
import marker from '@assets/images/avatar/marker.svg';
import { useIntl } from 'react-intl';

interface NavLinkProps {
  isActive: boolean;
  label: string;
  icon: string;
  to: string;
}

interface IMapStateToProps {
  loginStore: ILoginState;
}

const CustomNavLink: React.FC<NavLinkProps> = ({ isActive, label, icon, to }) => (
  <li className="nav-item">
    <NavLink to={to} className={`nav-link ${isActive ? 'active' : ''}`}>
      <i className={`${icon} fa-fw me-2`}></i>
      {label}
    </NavLink>
  </li>
);

const SideNav: React.FC = () => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  
  const [userData, setUserData] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [imageValid, setImageValid] = useState(false);
  
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const accountName = login.account?.name;

  useEffect(() => {
    async function fetchUserData() {
      const user = login?.user;
      if (user) {
        try {
          setUserData(user);
        } catch (error) {
          console.error('Error parsing user data:', error);
        }
      }
      setLoading(false);
    }
    fetchUserData();
  }, []);

  useEffect(() => {
    handleImage();
  }, [login?.user?.userAdditionalData?.profilePhoto]);

  const handleImage = async () => {
    var image = new Image();
    image.onload = () => setImageValid(true)
    image.onerror = () => setImageValid(false)
    image.src = login?.user?.userAdditionalData?.profilePhoto || '';
  };

  const signOut = () => {
    dispatch(logout());
    history.push(`/${accountName}/log-in`);
  };

  // Define state or props that determine which nav item is active
  const activePage: any = location.pathname.split('/')[2] || 'personal-information'; // This value should ideally come from router or parent component state

  if (loading) {
    return (
      <div className="centered-spinner">
        <Spin size="large" />
      </div>
    );
  }
  const intl = useIntl();
  return (
    <div className="col-lg-4 col-xl-3">
      <div className="offcanvas-lg offcanvas-end" tabIndex={-1} id="offcanvasSidebar">
        <div className="offcanvas-header justify-content-end pb-2">
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body p-3 p-lg-0">
          <div className="card bg-light w-100">
            <div className="position-absolute top-0 end-0 p-3">
              <NavLink to={`/${accountName}/personal-information`} className="text-primary-hover" title="Edit profile">
                <i className="bi bi-pencil-square"></i>
              </NavLink>
            </div>
            <div className="card-body p-3">
              <div className="text-center mb-3">
                <div className="avatar avatar-xl mb-2">
                  <img
                    className="avatar-img rounded-circle border border-2 border-white"
                    src={!imageValid ? marker : userData?.userAdditionalData?.profilePhoto}
                    // src={`${!imageValid ? marker : userData?.userAdditionalData?.profilePhoto}?${new Date().getTime()}`}
                    alt="avatar"
                  />
                </div>
                <h6 className="mb-0"></h6>
                <NavLink
                  to={`/${accountName}/company-settings`}
                  className="text-reset text-primary-hover small"
                >
                  {accountName}
                </NavLink>
                <hr />
              </div>
              <ul className="nav nav-pills-primary-soft flex-column">
                <CustomNavLink
                  isActive={activePage === 'personal-information'}
                  label={intl.formatMessage({ id: 'Personal.Information' })}
                  icon="bi bi-person"
                  to={`/${accountName}/personal-information`}
                />
                <CustomNavLink
                  isActive={activePage === 'account-settings'}
                  label={intl.formatMessage({ id: 'settings' })}
                  icon="bi bi-gear"
                  to={`/${accountName}/account-settings`}
                />
                <CustomNavLink
                  isActive={activePage === 'account-payment'}
                  label={intl.formatMessage({ id: 'payment.details' })}
                  icon="bi bi-credit-card"
                  to={`/${accountName}/account-payment`}
                />
                <CustomNavLink
                  isActive={activePage === 'booking'}
                  label={intl.formatMessage({ id: 'my.bookings' })}
                  icon="bi bi-suitcase-lg"
                  to={`/${accountName}/bookings`}
                />
                <CustomNavLink
                  isActive={activePage === 'account-rewards'}
                  label={intl.formatMessage({ id: 'my.rewards' })}
                  icon="bi bi-trophy"
                  to={`/${accountName}/account-rewards`}
                />
                {/* <CustomNavLink
                  isActive={activePage === 'account-credit'}
                  label="My Trip Credits"
                  icon="bi bi-coin"
                  to={`/${accountName}/account-credit`}
                /> */}
                <CustomNavLink
                  isActive={activePage === 'account-saved'}
                  label={intl.formatMessage({ id: 'saved.properties' })}
                  icon="bi bi-bookmark-check"
                  to={`/${accountName}/account-saved`}
                />
                <li className="nav-item">
                  <button className="nav-link text-danger bg-danger-soft-hover" style={{width: '100%', textAlign: 'left'}} onClick={signOut}>
                    <i className="bi bi-power fa-fw me-2"></i>
                    {intl.formatMessage({ id: 'sign.out' })}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideNav;
